import ErrorC from '@/components/alert_components/error/ErrorC';

const VALIDATION_ERROR_MSG = 'validation error';
const CONFIRMATION_MSG = 'confirmation';

const extractFieldName = (field) => {
    return field.includes('.') ? field.split('.')[1] : field;
}
export { extractFieldName };

const extractFieldUUID = (field) => {
    return field.includes('.') ? field.split('.')[0].replace(/[^a-z0-9\\-]+/g, "") : field;
}

const getErrorFields = (error, uuid) => {
    let errorFields = error.fields;

    if (errorFields.length <= 0) {
        errorFields = ['global_no_field_error'];
    }

    if (uuid == undefined) { return errorFields }

    return errorFields.filter(field => extractFieldUUID(field) === uuid);
}

export default {

    extractErrors(errors, fields, uuid = undefined) {
        const mappedErrors = this.extractErrorsForMonitor(errors, fields, uuid);
        const errorsForValidator = this.extractErrorsForValidator(errors, uuid);

        return { mappedErrors, errorsForValidator };
    },

    extractErrorsForMonitor(errors, fields, uuid = undefined) {
        return errors.flatMap(error => {
            let errorFields = getErrorFields(error, uuid);

            const mappedErrors = [];
            errorFields.forEach((field) => {
                mappedErrors.push(new ErrorC(error, field, fields, fields?.[field]?.name))
            });
            return mappedErrors;
        });
    },

    extractErrorsForValidator(errorObj, uuid = undefined) {
        const errors = {};
        errorObj.forEach(error => {
            let errorFields = getErrorFields(error, uuid);

            errorFields.forEach(field => {
                errors[field] = error.message;
            });
        });
        return errors;
    },

    isValidationError(message) {
        return message === VALIDATION_ERROR_MSG;
    },

    isConfirmationError(message) {
        return message === CONFIRMATION_MSG;
    }
}
